import React, { useEffect } from "react";
import { initCursor } from "../utils/animations";

/* ═══════════════════════════════════════════════════════════
   CUSTOM CURSOR — Gold dot + trailing ring
   Heavy oil dampening · mix-blend difference
   ═══════════════════════════════════════════════════════════ */

const CustomCursor = () => {
  useEffect(() => {
    const cleanup = initCursor();
    return cleanup;
  }, []);

  return (
    <>
      <div className="lux-cursor" aria-hidden="true" />
      <div className="lux-cursor-ring" aria-hidden="true" />
    </>
  );
};

export default CustomCursor;